import React, { useState } from 'react';
import axios from 'axios';

export default function ApiGoogleVision() {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState('');

    const analyze = async (event) => {
        event.preventDefault();
        setError('');
        setResult(null);

        if (!file) {
            setError('Selecciona un PDF.');
            return;
        }

        const formData = new FormData();
        formData.append('pdf', file);
        setLoading(true);

        try {
            const response = await axios.post('/api-google-vision/analyze', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            setResult(response.data);
        } catch (requestError) {
            const message = requestError.response?.data?.message || 'No se pudo analizar el PDF.';
            setError(message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="card card-custom">
            <div className="card-header">
                <div className="card-title">
                    <h3 className="card-label">Google Vision PDF</h3>
                </div>
            </div>
            <div className="card-body">
                <form onSubmit={analyze}>
                    <div className="form-group">
                        <label>PDF</label>
                        <input
                            type="file"
                            accept="application/pdf"
                            className="form-control"
                            onChange={(event) => setFile(event.target.files?.[0] || null)}
                        />
                    </div>
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                        {loading ? 'Analizando...' : 'Analizar PDF'}
                    </button>
                </form>

                {error && (
                    <div className="alert alert-danger mt-5 mb-0">
                        {error}
                    </div>
                )}

                {result && (
                    <div className={`alert mt-5 mb-0 ${result.found ? 'alert-warning' : 'alert-success'}`}>
                        <div className="font-weight-bold">
                            {result.found
                                ? 'Se encontro el texto "Documento sin validez oficial".'
                                : 'No se encontro el texto "Documento sin validez oficial".'}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
